module.exports = __webpack_public_path__ + "static/media/fashion-3.8afb8376.jpg";